import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client/core';

const GET_CLIENTS = gql`
  query ListBuyers($pagination: PaginationInput) {
    buyers(pagination: $pagination) {
      nodes {
        uid
        formalName
        email
        phone
      }
      pagination {
        perPage
        totalPages
        page
      }
    }
  }
`;

export const useGetClients = (input) => {
  const { loading, error, data, refetch } = useQuery(GET_CLIENTS, {
    variables: input,
  });

  return { loading, error, data, refetch };
};
